import React from "react";
import imgOne from "../../assets/images/services-img1.jpg";
import imgTwo from "../../assets/images/services-img2.jpg";
import imgThree from "../../assets/images/services-img3.jpg";

class TollFreeServices extends React.Component {
  render() {
    return (
      <section id="toll-free-services" className="services-area ptb-80">
        <div className="container">
          <div className="section-title">
            <h2>
              SHAKEN/STIR <span>Call Authentication</span>
            </h2>
            <p>
              Build caller trust, reduce spoofing, and improve answer rates with
              verified call identity. This layout mirrors a modern trust page
              experience and uses placeholder imagery for now.
            </p>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <h3>Why it matters</h3>
              <p>
                Robocalls and caller ID spoofing damage brand reputation and
                lead to lower answer rates. SHAKEN/STIR digitally signs call
                identity so carriers can verify the caller and display trust
                indicators to recipients.
              </p>
              <ul>
                <li>Confirm caller identity across the call path.</li>
                <li>Increase answer rates with verified branding signals.</li>
                <li>Protect customers from spoofed numbers and fraud.</li>
              </ul>
            </div>
            <div className="col-lg-6 col-md-12">
              <img className="img-fluid" src={imgOne} alt="Placeholder" />
            </div>
          </div>

          <div className="row pt-5">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>
                  How <span>SHAKEN/STIR</span> Works
                </h2>
                <p>
                  A call is signed by the originating provider, verified by
                  downstream carriers, and labeled with an attestation level
                  that reflects how confidently the caller identity is known.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="single-services">
                <div className="services-img">
                  <img src={imgTwo} alt="Placeholder" />
                  <div className="icon">
                    <i className="fa fa-shield"></i>
                  </div>
                </div>
                <div className="services-content">
                  <h3>Sign</h3>
                  <p>
                    The originating network signs call identity using
                    certificates tied to the business.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="single-services">
                <div className="services-img">
                  <img src={imgThree} alt="Placeholder" />
                  <div className="icon">
                    <i className="fa fa-check-circle"></i>
                  </div>
                </div>
                <div className="services-content">
                  <h3>Verify</h3>
                  <p>
                    Downstream carriers verify the signature and assign an
                    attestation level.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="single-services">
                <div className="services-img">
                  <img src={imgOne} alt="Placeholder" />
                  <div className="icon">
                    <i className="fa fa-phone"></i>
                  </div>
                </div>
                <div className="services-content">
                  <h3>Display</h3>
                  <p>
                    Verified calls can display a trust indicator to recipients,
                    improving answer rates.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row align-items-center pt-5">
            <div className="col-lg-6 col-md-12 order-lg-2">
              <h3>Benefits for your business</h3>
              <p>
                A consistent call authentication strategy helps protect your
                brand while making it easier for customers to recognize
                legitimate calls.
              </p>
              <ul>
                <li>Higher answer rates and stronger customer trust.</li>
                <li>Reduced spoofing and call fraud risk.</li>
                <li>Improved call deliverability and labeling outcomes.</li>
              </ul>
            </div>
            <div className="col-lg-6 col-md-12 order-lg-1">
              <img className="img-fluid" src={imgTwo} alt="Placeholder" />
            </div>
          </div>

          <div className="row pt-5">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>
                  A simple <span>implementation path</span>
                </h2>
                <p>
                  We guide you through registration, number association, and
                  verification so your outbound calls get the strongest
                  attestation possible.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="single-services">
                <div className="services-content">
                  <h3>1. Verify your business</h3>
                  <p>
                    Provide business identity details and complete required
                    vetting.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="single-services">
                <div className="services-content">
                  <h3>2. Associate numbers</h3>
                  <p>
                    Map phone numbers to your verified profile and trust
                    product.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="single-services">
                <div className="services-content">
                  <h3>3. Launch with confidence</h3>
                  <p>
                    Place verified calls, monitor results, and optimize for
                    answer rates.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-5">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>
                  Ready to <span>get started</span>?
                </h2>
                <p>
                  Tell us about your outbound calling needs and we will tailor
                  a SHAKEN/STIR rollout plan.
                </p>
                <a href="/#contact" className="btn btn-primary">
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default TollFreeServices;
